import { AirplaneIcon, BuildingsIcon, UsersIcon } from "@phosphor-icons/react";
import { useTranslations } from "use-intl";

import { Image } from "@/components/Image/Image";

const iconMap = {
  airplane: AirplaneIcon,
  buildings: BuildingsIcon,
  users: UsersIcon,
};

type IconName = keyof typeof iconMap;

export function AnimatedLoader({ icon = "airplane" }: { icon?: IconName }) {
  const t = useTranslations();
  const Icon = iconMap[icon] || AirplaneIcon;

  return (
    <div
      className="relative flex h-[68px] w-[68px] flex-col items-center justify-center"
      role="status"
      aria-label={t("loading")}
    >
      <Image
        src="/tzarrow.svg"
        className="arrow top-arrow"
        alt=""
        width={15}
        height={15}
        aria-hidden
      />
      <Image
        src="/tzarrow.svg"
        className="arrow bottom-arrow"
        alt=""
        width={15}
        height={15}
        aria-hidden
      />
      <Icon size={40} color="#003E2B" className="absolute z-10" aria-hidden />
    </div>
  );
}
